<script lang="ts">
import { defineComponent, reactive } from 'vue'
import LayoutEventCardsCols from '@/components/events/LayoutEventCardsCols.vue'
import PaginationDefault from '@/components/pagination/PaginationDefault.vue'
import stateInitializer from '@/models/stateInitializer'
import paginationModel from '@/models/pagination'

const PAGINATION_QUERY = 'page'

export default defineComponent({
  name: 'EventsMain',

  components: {
    LayoutEventCardsCols,
    PaginationDefault,
  },

  setup() {
    interface State {
      events: SolutionEventItem[],
      pagination: Pagination,
    }
    const state: State = reactive({
      events: [],
      pagination: {
        page: 0,
        per: 0,
        totalCount: 0,
      },
    })
    stateInitializer(state, 'main')
    const { pagination } = paginationModel(state.pagination)

    return {
      // constants
      PAGINATION_QUERY,

      // data
      state,

      // computed
      pagination,
    }
  },
})
</script>

<template>
  <section class="section">
    <div
      class="l-unit__eventIndex"
      :data-total-page="pagination.totalPage">
      <div class="l-unit__eventIndex--description">
        <LayoutEventCardsCols :items="state.events" />
      <!-- /.l-unit__eventIndex description --></div>

      <div
        v-if="pagination.totalPage"
        class="l-unit__eventIndex--action is-pagination">
        <PaginationDefault
          :page="pagination.page"
          :offset="4"
          :total-page="pagination.totalPage || 0"
          :query-param="PAGINATION_QUERY" />
      <!-- /.l-unit__eventIndex action --></div>
    <!-- /.l-unit__eventIndex --></div>
  </section>
</template>

<style lang="sass" scoped>
// layout
.l-unit__eventIndex
  $root: &
  display: flex
  flex-direction: column

  & &--description
    width: 100%

  & &--action
    &.is-pagination
      width: 100%
      margin-top: 3em

  +breakpoint
    #{$root}--action
      &.is-pagination
        margin-top: 0
        padding-top: 12px
        border-top: 1px solid $border-x-light-gray

    &[data-total-page="1"]
      #{$root}--action
        &.is-pagination
          padding-top: 0
          border-top: none
</style>
